<template>
  <div class="coursecontainer">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 教程内页 -->
    <div class="courseDetail">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/task' }">商业订单</el-breadcrumb-item>
          <el-breadcrumb-item>{{ detail.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="course-body">
        <div class="left">
          <div class="lan-des opensdet-intro-des clearfix">
            <h4 class="title">{{detail.title}}</h4>
            <div class="info">
              <h4 class="bt">基本信息</h4>
              <div class="main">
                <span>
                  佣金：
                  <p>¥ {{detail.price}}</p>
                </span>
                <span>
                  用途：
                  <p>商用</p>
                </span>
                <span>
                  来源：
                  <p>美课官方</p>
                </span>
                <span>
                  截止：
                  <p>{{detail.end_time}}</p>
                </span>
              </div>
            </div>
            <div class="content">
              <p v-html=" detail.content "></p>
            </div>

          </div>
          <h4 class="bt" style="text-align:left; margin-top:50px;">兼职流程</h4>
          <img src="../assets/task.jpg" width="100%" style="margin-top:0px;"/>
        </div>
        <div class="right">
          <div class="mulu">
            <p class="mu_title">　注意事项</p>
            <div class="menu-list">
              <p>收入以最终结算为准，可能会有部分出入请知悉~</p>
              <a :href="detail.url" target="_balank">
                <el-button class="dowload" @click="centerDialogVisible = true" type="info">立即报名</el-button>
              </a>
            </div>
          </div>
          <div class="user-list">
            <div class="main-title">报名列表</div>
            <div class="main">
              <div class="li" v-for="(item,i) in detail.signUser" :key="i">
                <img :src="item.avatar_url">
                <span class="name">{{item.nickname}}</span>
                {{item.create_time}}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <el-dialog
      title="报名确认"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>请联系班主任老师沟通兼职任务需求。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sign()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'home',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        detail: {},
        centerDialogVisible:false
      }
    },
    created() {
      this.getInfo()
    },
    methods: {
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/task/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.detail = res.data.data
        }).catch(err => {})
      },
      // 报名
      sign() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Task/SignUp', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "task_id": this.detail.id
          }
        }).then(res => {
          this.centerDialogVisible = false
          // if (res.data.code == 200) {
          //   this.$message({
          //     message: res.data.msg,
          //     type: 'success'
          //   });
          // } else {
          //   this.$message(res.data.msg);
          // }
        }).catch(err => {
          console.log(err)
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .bt {
    line-height: 15px;
    padding-left: 10px;
    border-left: 3px solid #FABE00;
    height: 15px;
    font-size: 18px;
    margin: 30px 0;
    font-weight: normal;
    color: #535353
  }

  .info .main {
    width: 100%;
    display: flex;
    margin-top: 30px;

    span {
      width: 25.3%;
      margin: 20px 0;
      text-align: left;
      font-size: 14px;
      color: #797A7B;
    }

    span p {
      font-size: 18px;
      margin-top: 5px;
      color: #535353
    }
  }

  .introduction {
    padding: 30px 40px;
    background: #f0f4f5;
    margin: 30px 10px 10px 0;
    border-radius: 6px;
    font-size: 14px;
    line-height: 25px;
  }

  .course_content_box {
    overflow: hidden;
  }

  /deep/.course_content_box img {
    max-width: 850px !important;
    width: 100% !important;
  }

  .content {
    margin: 30px 0 10px 0;
  }

  /deep/ .content img {
    max-width: 850px !important;
  }

  // 右侧
  .pass {
    font-size: 16px;
    margin-top: 20px;
  }

  .pass b {
    font-size: 22px;
    color: #FAC007
  }

  .user-list {
    margin-top: 20px;
    background-color: rgb(246, 248, 250);
    padding: 20px 10px;
    border-radius: 14px;
    .main-title {
      font-size:18px;
    }

    .li {
      margin-top: 10px;
      line-height: 50px;
      font-size:14px;
      color: #999;
      display: flex;
      width: 100%;

      img {
        width: 35px;
        height: 35px;
        border-radius: 60%;
        margin: 9px 5px 0 20px;
      }

      .name {
        width: 30%;
      }
    }
  }


  .courseDetail {
    margin-bottom: 30px;
    min-height:80vh;

    .course-body {
      .right {
        width:300px;
        .mulu {
          background-color: rgb(246, 248, 250);
          padding: 20px 10px;
          border-radius: 14px;
          text-align: center;

          p {
            width: 70%;
            margin: 20px auto;
          }

          .dowload {
            width: 80%;
            margin: 10px 0;
            background: black;
            font-size: 14px;
          }

          .dowload a {
            color: white;
          }

          .mu_title {
            font-size: 18px;
            color: #212B34;
            font-weight: 500;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .opensdet-intro-des {
    border-bottom: 1px solid #F1F3F5;
    border-radius: 1px;
  }

  .opensdet-intro-des {
    padding-bottom: 25px;
  }

  .lan-des {
    position: relative;
    display: table-cell;
    text-align: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .opensdet-intro-des .title {
    font-size:28px;
    padding: 20px 0 0 0;
    font-weight:normal;
  }

  .opensdet-intro-des .opensdet-intro-title {
    margin: unset;
    color: #212B34;
    font-weight: 500;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 35px;
  }

  .vcourse-detail-share .left {
    display: inline-block;
    padding-right: 20px;
  }

  .details-tags {
    white-space: normal;
    color: #B1B5B9;
  }

  .details-tags {
    min-height: 24px;
    margin: 10px 0;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
  }

  .details-tags>a:first-child {
    margin-left: 0;
  }

  .courseDetail {
    padding: 0px;
    width: 1200px;
    margin: 30px auto;
  }

  .heads {
    display: flex;
  }

  .active {
    font-weight: 600;
    color: #18252c !important;
    border-bottom: 4px solid #00d753;
  }

  .content_top {
    padding: 40px 0 10px 0;
  }

  .course-body {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding-bottom: 50px;
    padding-left: 0;
    position: relative;
  }

  .course-body .left {
    width: 800px;
    margin-right: 80px;
  }

  .course-body .left .course-banner {
    width: 850px !important;
    height: 500px !important;
  }





</style>



// WEBPACK FOOTER //
// src/components/TaskDetail.vue